import LegalLayout, { Section } from "@/components/landing/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout label="Rechtliches" title="Datenschutz" testid="datenschutz-page">
      <Section index="01" title="Verantwortliche Stelle" testid="datenschutz-section-verantwortlicher">
        <p>
          Der Schutz Ihrer personenbezogenen Daten hat für unser Unternehmen
          höchste Priorität. Wir verarbeiten Ihre Daten ausschließlich im
          Einklang mit den geltenden gesetzlichen Vorschriften, insbesondere
          der Datenschutz-Grundverordnung (DSGVO).
        </p>
        <p>
          DROPS – Drohnen Operation Service
          <br />
          DROPS Dienstleistung Schäfer · Daniel Schäfer
          <br />
          Viktor-Reuter-Straße 7, 44623 Herne
          <br />
          E-Mail:{" "}
          <a data-testid="datenschutz-email-link" href="mailto:drops33@web.de" className="text-white transition-colors duration-300 hover:text-[#F5B301]">
            drops33@web.de
          </a>
          {" "}· Telefon:{" "}
          <a data-testid="datenschutz-phone-link" href="tel:+49177857960" className="text-white transition-colors duration-300 hover:text-[#F5B301]">
            0177 857960
          </a>
        </p>
      </Section>

      <Section index="02" title="Erhebung und Verarbeitung von Daten" testid="datenschutz-section-erhebung">
        <p>
          Im Rahmen unserer Dienstleistungen (z. B. Drohnenflüge, Inspektionen,
          Dokumentationen) werden ausschließlich die Daten erhoben und
          verarbeitet, die zur Durchführung des jeweiligen Auftrags erforderlich
          sind.
        </p>
        <p>
          Beim Aufruf dieser Website speichert der Hosting-Dienstleister
          automatisch technische Zugriffsdaten (z. B. IP-Adresse, Zeitpunkt des
          Zugriffs, Browsertyp) in Server-Log-Dateien. Rechtsgrundlage ist
          Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem stabilen
          und sicheren Betrieb).
        </p>
      </Section>

      <Section index="03" title="Zweck der Datenverarbeitung" testid="datenschutz-section-zweck">
        <p>Die Verarbeitung erfolgt ausschließlich zu folgenden Zwecken:</p>
        <ul className="list-none space-y-2">
          {[
            "Durchführung von Inspektions- und Dokumentationsarbeiten",
            "Erstellung von Berichten und Analysen",
            "Kommunikation mit Auftraggebern",
            "Weitergabe an berechtigte Dritte (z. B. Ingenieurbüros), sofern erforderlich",
            "Bearbeitung von Anfragen über das Kontaktformular (Art. 6 Abs. 1 lit. b DSGVO)",
          ].map((item) => (
            <li key={item} className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 shrink-0 bg-[#F5B301]" />
              {item}
            </li>
          ))}
        </ul>
      </Section>

      <Section index="04" title="Datensicherheit" testid="datenschutz-section-sicherheit">
        <p>
          Wir setzen technische und organisatorische Maßnahmen ein, um Ihre
          Daten bestmöglich zu schützen:
        </p>
        <ul className="list-none space-y-2">
          {[
            "Datenträger werden nach Nutzung passwortgeschützt und verschlüsselt",
            "Zugriff erfolgt ausschließlich durch autorisierte Personen",
            "Speicherung erfolgt nur für die notwendige Dauer",
          ].map((item) => (
            <li key={item} className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 shrink-0 bg-[#F5B301]" />
              {item}
            </li>
          ))}
        </ul>
      </Section>

      <Section index="05" title="Bild- und Videodaten" testid="datenschutz-section-bilddaten">
        <p>Bei Drohnenaufnahmen achten wir besonders auf den Schutz Dritter:</p>
        <ul className="list-none space-y-2">
          {[
            "Nicht relevante Bereiche (z. B. Nachbargrundstücke) werden ausgeblendet oder verpixelt",
            "Es werden nur auftragsbezogene Daten verarbeitet",
          ].map((item) => (
            <li key={item} className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 shrink-0 bg-[#F5B301]" />
              {item}
            </li>
          ))}
        </ul>
      </Section>

      <Section index="06" title="Weitergabe von Daten" testid="datenschutz-section-weitergabe">
        <p>
          Eine Weitergabe erfolgt ausschließlich an den Auftraggeber und an
          ausdrücklich beauftragte Stellen (z. B. Ingenieurbüros). Eine
          Weitergabe an unberechtigte Dritte erfolgt nicht.
        </p>
        <p>
          Anfragen aus dem Kontaktformular werden in einer Datenbank auf
          Servern unseres Hosting-Dienstleisters gespeichert und uns per
          E-Mail übermittelt.
        </p>
      </Section>

      <Section index="07" title="Schriftarten (Webfonts)" testid="datenschutz-section-fonts">
        <p>
          Diese Website lädt Schriftarten von externen Anbietern (Google Fonts
          und Fontshare). Beim Aufruf der Seite wird dabei eine Verbindung zu
          Servern dieser Anbieter hergestellt und Ihre IP-Adresse übertragen.
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
          Interesse an einer einheitlichen Darstellung).
        </p>
      </Section>

      <Section index="08" title="Cookies & Tracking" testid="datenschutz-section-cookies">
        <p>
          Diese Website verwendet keine Cookies und kein Tracking. Es findet
          keine Analyse Ihres Nutzungsverhaltens statt.
        </p>
      </Section>

      <Section index="09" title="Ihre Rechte" testid="datenschutz-section-rechte">
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul className="list-none space-y-2">
          {[
            "Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)",
            "Berichtigung unrichtiger Daten (Art. 16 DSGVO)",
            "Löschung Ihrer Daten, sofern keine gesetzliche Aufbewahrungspflicht besteht (Art. 17 DSGVO)",
            "Einschränkung der Verarbeitung (Art. 18 DSGVO)",
            "Datenübertragbarkeit (Art. 20 DSGVO)",
            "Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)",
          ].map((right) => (
            <li key={right} className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 shrink-0 bg-[#F5B301]" />
              {right}
            </li>
          ))}
        </ul>
        <p>
          Zudem besteht ein Beschwerderecht bei der Aufsichtsbehörde —
          zuständig ist die Landesbeauftragte für Datenschutz und
          Informationsfreiheit Nordrhein-Westfalen (LDI NRW).
        </p>
      </Section>

      <Section index="10" title="Kontakt zum Datenschutz" testid="datenschutz-section-kontakt">
        <p>
          Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:{" "}
          <a data-testid="datenschutz-kontakt-link" href="mailto:drops33@web.de" className="text-white transition-colors duration-300 hover:text-[#F5B301]">
            drops33@web.de
          </a>
        </p>
        <p>
          Diese Datenschutzerklärung hat den Stand August 2026. Wir passen sie
          an, sobald Änderungen der Website oder der Rechtslage dies
          erforderlich machen.
        </p>
      </Section>
    </LegalLayout>
  );
}
